import styled from "styled-components";
export const Styles = styled.div`
  .floating-card {
    transform: translateY(50%);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 80px;
  }
  .floating-card .item {
    color: var(--dark-color);
  }
  .floating-card .item:nth-child(2) {
    padding-inline: 80px;
    border-inline: 1px solid #84829a;
  }
  .floating-card .item .count {
    font-weight: bold;
    font-size: 20px;
  }
  @media (max-width: 768px) {
    .floating-card {
      font-size: 15px;
      transform: translateY(10%);
      gap: 30px;
      padding: 40px 30px;
    }
    .floating-card .item .count {
      font-weight: bold;
      font-size: 16px;
    }
    .floating-card .item:nth-child(2) {
      padding-inline: 30px;
    }
  }
`;
